import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ETR_WeeklySchema } from "./WeeklyReportSchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getCustomer, SUPPORTED_CUSTOMERS } from "../../../MainPage/VersionInfo";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";

const weeklyTestCodes = ["ETR_WeeklyTests"];

const masterKey = [
  { key: "C", value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },

  { key: "G", value: "Governed by Special Instruction." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant." },
  { key: "N", value: "Test Not Applicable." },
];

const ReportView = (props) => {
  let { data } = props;
  const decodedData = Array.isArray(data.decodedData) ? data.decodedData : [];

  const decodedWeeklyData = decodedData.filter((t) => weeklyTestCodes.includes(t.testCode));
  const weeklyData = decodedWeeklyData && decodedWeeklyData.length > 0 ? decodedWeeklyData[0].summary : {};

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Highway Grade Crossing Test & Inspections" {...props} fontSizeOverride={"35px"} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} data={{ ...data }} />
      <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
      <span className="spacer"></span>

      <table className="table-bordered" style={{ fontSize: "20px" }}>
        {ETR_WeeklySchema.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={weeklyData} />;
        })}
      </table>
    </div>
  );
};

const ETR_WeeklyReport = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView data={{}} />;
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [...weeklyTestCodes]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report, i) => <ReportView key={i} {...props} data={report} />);
};

export default ETR_WeeklyReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ETR/WeeklyReport/index.jsx